/* eslint-disable import/no-anonymous-default-export */
import coreApi from "../../lib/coreApi";
import { hasCap } from "../../lib/permissions";

export default {
  bulkUpdateEmployees: (data) => {
    let url = `/admin/employees-bulk-update`;
    let result = coreApi.PATCH(url, data)
    return result
  },
  onBoardEmployees: (data) => {
    let url = `/admin/employees/onboard`;
    let result = coreApi.POST(url, data);
    return result;
  },
  onBoardEmployeesVerify: (data) => {
    const user = JSON.parse(localStorage.user)
    // Backoffice dry-run verify for supers OR staff with employee_upload.view;
    // company admins use their own /admin verify.
    let url = `${hasCap(user, "employee_upload.view") ? '/backoffice/employees/onboard/verify' : '/admin/employees/onboard/verify'}`;
    let result = coreApi.POST(url, data);
    return result;
  },
  inviteEmployees: (data) => {
    const user = JSON.parse(localStorage.user)
    let url = `${user?.is_hr ? '/hr/employees/invite' : '/admin/employees/invite'}`;
    let result = coreApi.POST(url, data);
    return result;
  },
  invitePendingEmployees: (data) => {
    let url = `/admin/employees/invite-pending`;
    let result = coreApi.POST(url, data);
    return result;
  },
  updateEmployee: (data, employee_id) => {
    const user = JSON.parse(localStorage.user)
    let url = `${window.location.pathname.includes("backoffice")
      ? "/backoffice"
      : window.location.pathname.includes("company")
        ? (user?.is_admin ? "/admin"
          : "/hr") : ""
      }/employees/${employee_id}`;
    let result = coreApi.PATCH(url, data);
    return result;
  },
  createPayStackProfile: (employee_id, data) => {
    let url = `${window.location.pathname.includes("backoffice")
      ? "/backoffice"
      : window.location.pathname.includes("company")
        ? "/admin"
        : ""
      }/employees/${employee_id}/paystack`;
    return coreApi.POST(url, data);
  },
  getOvertimeList: (data) => {
    let qp = "";
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        qp = qp + `&${key}=${data[key]}`;
      }
    }

    if (qp && qp.length && qp.length > 1) qp = qp.replace(qp.charAt(0), "?");

    let url = `${JSON.parse(localStorage.getItem("user"))?.is_super
      ? "/backoffice"
      : JSON.parse(localStorage.getItem("user"))?.is_admin
        ? "/admin"
        : ""
      }/overtimes${qp}`;
    let result = coreApi.GET(url);
    return result;
  },
  getOvertimeInfo: (overtime_id) => {
    let url = `${JSON.parse(localStorage.getItem("user"))?.is_super
      ? "/backoffice"
      : JSON.parse(localStorage.getItem("user"))?.is_admin
        ? "/admin"
        : ""
      }/overtimes/${overtime_id}`;
    let result = coreApi.GET(url);
    return result;
  },
  approveOvertime: (overtime_id, data) => {
    let url = `/admin/overtimes/${overtime_id}/approve`;
    let result = coreApi.PATCH(url, data);
    return result;
  },
  rejectOvertime: (overtime_id, data) => {
    let url = `/admin/overtimes/${overtime_id}/reject`;
    let result = coreApi.PATCH(url, data);
    return result;
  },
  getLeaveList: (data) => {
    let qp = "";
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        qp = qp + `&${key}=${data[key]}`;
      }
    }

    if (qp && qp.length && qp.length > 1) qp = qp.replace(qp.charAt(0), "?");

    let url = `/admin/leaves${qp}`;
    let result = coreApi.GET(url);
    return result;
  },
  createLeave: (data) => {
    let url = `/admin/leaves`;
    let result = coreApi.POST(url, data);
    return result;
  },
  getCompanyPayments: (data) => {
    let qp = "";
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        qp = qp + `&${key}=${data[key]}`;
      }
    }

    if (qp && qp.length && qp.length > 1) qp = qp.replace(qp.charAt(0), "?");

    let url = `${JSON.parse(localStorage.getItem("user"))?.is_super
      ? "/backoffice/company/payments"
      : JSON.parse(localStorage.getItem("user"))?.is_admin
        ? "/company/payments"
        : ""
      }${qp}`;
    let result = coreApi.GET(url);

    return result;

  },
  getWithdrawalLimitCategories: (filters) => {
    let url = `${JSON.parse(localStorage.getItem("user"))?.is_super
      ? "/backoffice/withdrawal-limits"
      : JSON.parse(localStorage.getItem("user"))?.is_admin
        ? "/admin/withdrawal-limits"
        : ""}`;

    let qp = "";
    for (var key in filters) {
      if (filters.hasOwnProperty(key)) {
        qp = qp + `&${key}=${filters[key]}`;
      }
    }

    if (qp && qp.length && qp.length > 1) qp = qp.replace(qp.charAt(0), "?");
    return coreApi.GET(`${url}${qp}`);
  },
  listEmployeeCompanyJoinRequests: (data) => {
    const user = JSON.parse(localStorage.getItem("user"))
    let url = `${hasCap(user, "join_requests.view")
      ? "/backoffice"
      : user?.is_admin
        ? "/admin"
        : user?.is_hr ? "/hr" : ""
      }/join-requests`;
    let qp = "";
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        qp = qp + `&${key}=${data[key]}`;
      }
    }

    if (qp && qp.length && qp.length > 1) qp = qp.replace(qp.charAt(0), "?");
    let result = coreApi.GET(`${url}${qp}`);
    return result;
  },
  updateEmployeeCompanyJoinRequest: (data, join_request_id) => {
    const user = JSON.parse(localStorage.getItem("user"))
    let url = `${hasCap(user, "join_requests.edit")
      ? "/backoffice"
      : user?.is_admin
        ? "/admin"
        : user?.is_hr ? "/hr" : ""
      }/join-requests/${join_request_id}`;
    let result = coreApi.PATCH(url, data);
    return result;
  },
  employeeCompanyJoinRequestApprove: (request_id) => {
    const user = JSON.parse(localStorage.getItem("user"))
    let url = `${hasCap(user, "join_requests.approve")
      ? "/backoffice"
      : user?.is_admin
        ? "/admin"
        : user?.is_hr ? "/hr" : ""
      }/join-requests/${request_id}/approve`;

    return coreApi.POST(url, {});
  },
  employeeCompanyJoinRequestReject: (request_id, data) => {
    const user = JSON.parse(localStorage.getItem("user"));
    let url = `${hasCap(user, "join_requests.reject")
      ? "/backoffice"
      : user?.is_admin
        ? "/admin"
        : user?.is_hr ? "/hr" : ""
      }/join-requests/${request_id}/reject`;

    return coreApi.POST(url, data);
  },
  changeEmployeePermission: (user_id, data) => {
    // pk is the target employee's user id. Endpoint accepts { is_admin, is_hr }
    // as body and is gated to company admins server-side; the UI hides the
    // control for anyone else and forbids self-modification, but the backend
    // is the state authority.
    let url = `${JSON.parse(localStorage.getItem("user"))?.is_super
      ? "/backoffice"
      : JSON.parse(localStorage.getItem("user"))?.is_admin
        ? "/admin"
        : ""
      }/change-permission/${user_id}`;
    return coreApi.PATCH(url, data);
  },
  employeeCompanyJoinRequestAuditLogs: (request_id, params) => {
    const user = JSON.parse(localStorage.getItem("user"));
    let url = `${hasCap(user, "join_requests.view")
      ? "/backoffice"
      : user?.is_admin
        ? "/admin"
        : user?.is_hr ? "/hr" : ""
      }/join-requests/${request_id}/audit-logs`;
    let qp = "";
    for (var key in params) {
      if (params && params.hasOwnProperty(key)) {
        qp = qp + `&${key}=${params[key]}`;
      }
    }
    if (qp && qp.length && qp.length > 1) qp = qp.replace(qp.charAt(0), "?");
    return coreApi.GET(`${url}${qp}`);
  },
  inviteCompanyAdmin: (data) => {
    const user = JSON.parse(localStorage.getItem("user"));
    let url = `${user?.is_super ? '/backoffice' : '/admin'}/invite/administrator`;
    return coreApi.POST(url, data);
  }
};
